export enum TranslationGroup {
  Common = 'common',
  Catalog = 'catalog',
}
